(function (angular, app) {
   "use strict";

   app.modules.common = {
      name: "app.Common"
      , constants : {
         appsettings : "GRPAppSettings"
         , appmessaging : "GRPAppMessaging"
         , accesscontrolenum : "GRPAccessControlEnum"
         , rolecheckenum : "GRPRoleCheckEnum"
         , gameenum : "GRPAppGameEnums"
         , calendarlist: "GRPAppCalendarConst"
         , themelist: "GRPAppThemeList"
         , countrylist : "GRPAppCountryConst"
         , equipmentlist : "GRPAppEquipmentConst"
         , genderenum : "GRPAppGenderConst"
         , regionlist : "GRPAppRegionsConst"
         , tourslideslist: "GRPAppTourSlidesConst"
         , handicaptypes: "GRPHandicapTypeConst"
      }
      , controllers : {
         
      }
      , decorators : {
         resource : "$resource"
         , routeprovider: ""
      }
      , directives : {
         focus : "ggFocusDirective"
      }
      , services : {
         eventbus: "ggEventBusFactory"
         //, geolocation: "g_GeoLocationFactory"
         , http: "gg_HTTPFactory"
         , functions: "ggFunctionsFactory"
         , storage: "ggStorageFactory"
      }
      , events : {
         viewChange : "UIViewChange"
         , coursehandicap: "UICourseHandicapModal"
         , httpRequest: "UIHttpRequest"
         , authChange: "UIAuthChange"
         , dragStart: "UIDragStart"
         , dragEnd: "UIDragEnd"
         , toggleProcessing: "UIToggleProcessing"
         , invitationUpdate : "UIInvitationUpdate"
      }
   };

   angular.module(app.modules.common.name, [
      "ngResource",
      "smoothScroll",
      "LocalStorageModule"
   ]);

}(angular, app));
